package org.multiplatform.kotfolio.models

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue,
) {
    Primary(hex = "#FFAE00", rgb = rgb(r = 255, g = 174, b = 0)), // Gold/Amber accent
    Secondary(hex = "#FFFFFF", rgb = rgb(r = 255, g = 255, b = 255)), // White text
    Background(hex = "#1A0A00", rgb = rgb(r = 26, g = 10, b = 0)), // Dark brown background
    Gray(hex = "#CFCFCF", rgb = rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    LighterGray(hex = "#F9F9F9", rgb = rgb(r = 249, g = 249, b = 249)),
}
